import React from 'react';
import styles from './JoinUnion.module.scss';

const PrivacyRights = () => {
    return (
        <div className="container mt-4">
            <div className="row mt-4">
                <div className="col-md-12">
                    <div className={`${styles.borderBox}`}>
                        <div>
                            <h5>Your rights under the Privacy Act</h5>
                            <p>You have the right to see a copy of any personal information held about you. If there are mistakes, you can ask for them to
                                be fixed or you can give a list of corrections about what you think is wrong.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyRights;